import { memo } from 'react'

import {
  FormControl,
  FormLabel,
  Stack,
  FormErrorMessage,
  Text,
} from '@chakra-ui/react'
import {
  SmallItem,
  ItemType,
} from 'src/legacy_modules/entities/small-item/entity'

import { RolePermissionCheckbox } from './role-permission-checkbox'

type RolePermissionSectionProps = {
  smallItem: SmallItem
  releaseTried: boolean
  onChangeSmallItem: (value: {
    smallItemUid: string
    values: { [key in keyof SmallItem]?: SmallItem[key] }
  }) => void
}

export const RolePermissionSection = memo<RolePermissionSectionProps>(
  function RolePermissionSection(props) {
    const { smallItem, releaseTried, onChangeSmallItem } = props

    return (
      <FormControl
        isInvalid={
          releaseTried &&
          smallItem.itemType !== ItemType.Label &&
          smallItem.rolePermissions.length === 0
        }
      >
        <FormLabel>入力権限</FormLabel>
        {smallItem.presetUsed ? (
          <Stack spacing="2">
            {smallItem.rolePermissions.map(rp => (
              <Text key={rp.role}>
                {rp.role}: {rp.permissionType}
              </Text>
            ))}
          </Stack>
        ) : (
          <RolePermissionCheckbox
            rolePermissions={smallItem.rolePermissions}
            onChange={rolePermissions => {
              onChangeSmallItem({
                smallItemUid: smallItem.uid,
                values: { rolePermissions },
              })
            }}
            disabled={smallItem.itemType === ItemType.Label}
          />
        )}
        <FormErrorMessage>
          入力権限を必ず1つ以上選択してください
        </FormErrorMessage>
      </FormControl>
    )
  },
)
